import axios from 'axios'
import router from '../router/router.js'
import { useUserStore } from '../stores/userStore'

const axiosInstance = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
})

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const userStore = useUserStore()
      userStore.clearUser()
      router.push({ name: 'welcome' })
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
